<template>
  <div v-if="feature">
    <div class="row">
      <EmbeddedHeader class="col" v-if="embedded" :feature="feature" />
      <BreadcrumbHeader class="col" v-else :feature="feature" />
      <form class="col-md-5">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Dataset:</span>
          </div>
          <select class="form-control form-control-lg"  v-model="resultSet">
            <option
              v-for="option in resultSetOptions"
              :key="option.value"
              :value="option.value">
              {{option.text}}
            </option>
          </select>
        </div>
      </form>
    </div>
    <hr>
    <CensusResults
      v-if="resultSet == 'CENSUS_2018'"
      :uuid="uuid"
      year="2018" />
    <CensusResults
      v-if="resultSet == 'CENSUS_2013'"
      :uuid="uuid"
      year="2013" />
    <CensusResults
      v-if="resultSet == 'CENSUS_2006'"
      :uuid="uuid"
      year="2006" />
  </div>
</template>

<script>
import gql from "graphql-tag";
import { LngLatBounds } from "mapbox-gl";
import BreadcrumbHeader from "@/components/Feature/BreadcrumbHeader";
import EmbeddedHeader from "@/components/Feature/EmbeddedHeader";
import CensusResults from "@/components/Feature/CensusResults";

export default {
  components: { BreadcrumbHeader, EmbeddedHeader, CensusResults },
  props: {
    uuid: String,
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      feature: null,
      resultSet: "CENSUS_2018",
      resultSetOptions:[
        { text: "2018 Census", value: "CENSUS_2018" },
        { text: "2013 Census", value: "CENSUS_2013" },
        { text: "2006 Census", value: "CENSUS_2006" }
      ]
    };
  },
  apollo: {
    feature: {
      query: gql`query fetchfeature($id: uuid!, $year: String){
        feature: features_by_pk(id: $id){
          id
          name
          source_identifier
          bounding_box
          layer{
            id
            name
            mapbox_identifier
          }
        }
      }`,
      variables(){
        return {
          id: this.uuid
        }
      }
    }
  },
  updated() {
    let bounds = this.feature.bounding_box.coordinates[0].map((coord)=>{
      return [coord[0], coord[1]]
    });
    this.$store.dispatch("fitBounds", LngLatBounds.convert(bounds));
    this.$store.dispatch("showLayerUrl", this.feature.layer.mapbox_identifier);
    this.$store.dispatch("highlightFeature", this.feature.source_identifier);
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Feature.vue